var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content change-charge-window",
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "destroy-on-close": true,
        title: _vm.title,
        width: "1300px",
        "before-close": _vm.cancel
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "config-module": "13011111",
              "row-data": _vm.rowData,
              "min-height": "400px"
            }
          })
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _vm.defaultProperties.editMode === "add"
          ? _c(
              "div",
              { staticStyle: { float: "left", "margin-bottom": "10px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.add }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "mini" },
                    on: { click: _vm.remove }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticStyle: { float: "right", "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini" },
                on: { click: _vm.saveEvent }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
            ),
            _c(
              "el-button",
              { attrs: { size: "mini" }, on: { click: _vm.cancel } },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }